// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SesionesRouteImport } from './routes/sesiones'
import { Route as PublicRouteImport } from './routes/public'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as EventosRouteImport } from './routes/eventos'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as BodasRouteImport } from './routes/bodas'
import { Route as AvisoLegalRouteImport } from './routes/aviso-legal'
import { Route as AccesoRouteImport } from './routes/acceso'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PropuestaTokenRouteImport } from './routes/propuesta.$token'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as AuthenticatedPresentacionRouteImport } from './routes/_authenticated/presentacion'
import { Route as AuthenticatedAppRouteImport } from './routes/_authenticated/app'
import { Route as EventoTokenCancionesRouteImport } from './routes/evento.$token.canciones'
import { Route as PortalEventosIdRouteImport } from './routes/portal.eventos.$id'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app.index'
import { Route as AuthenticatedAppWhatsappRouteImport } from './routes/_authenticated/app.whatsapp'
import { Route as AuthenticatedAppTareasRouteImport } from './routes/_authenticated/app.tareas'
import { Route as AuthenticatedAppSolicitudesRouteImport } from './routes/_authenticated/app.solicitudes'
import { Route as AuthenticatedAppPresupuestosRouteImport } from './routes/_authenticated/app.presupuestos'
import { Route as AuthenticatedAppPagosRouteImport } from './routes/_authenticated/app.pagos'
import { Route as AuthenticatedAppLeadsRouteImport } from './routes/_authenticated/app.leads'
import { Route as AuthenticatedAppHoyRouteImport } from './routes/_authenticated/app.hoy'
import { Route as AuthenticatedAppEventosRouteImport } from './routes/_authenticated/app.eventos'
import { Route as AuthenticatedAppContactosRouteImport } from './routes/_authenticated/app.contactos'
import { Route as AuthenticatedAppCompartirRouteImport } from './routes/_authenticated/app.compartir'
import { Route as AuthenticatedAppClientesRouteImport } from './routes/_authenticated/app.clientes'
import { Route as AuthenticatedAppCancionesRouteImport } from './routes/_authenticated/app.canciones'
import { Route as AuthenticatedAppCampanasRouteImport } from './routes/_authenticated/app.campanas'
import { Route as AuthenticatedAppCalendarioRouteImport } from './routes/_authenticated/app.calendario'
import { Route as AuthenticatedAppArchivosRouteImport } from './routes/_authenticated/app.archivos'
import { Route as AuthenticatedAppEventosIdRouteImport } from './routes/_authenticated/app.eventos.$id'
import { Route as AuthenticatedAppClientesIdRouteImport } from './routes/_authenticated/app.clientes.$id'

const SesionesRoute = SesionesRouteImport.update({
            id: '/sesiones',path: '/sesiones',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/public',path: '/public',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const PortalRoute = PortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => rootRouteImport
          })
const EventosRoute = EventosRouteImport.update({
            id: '/eventos',path: '/eventos',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const BodasRoute = BodasRouteImport.update({
            id: '/bodas',path: '/bodas',getParentRoute: () => rootRouteImport
          })
const AvisoLegalRoute = AvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => rootRouteImport
          })
const AccesoRoute = AccesoRouteImport.update({
            id: '/acceso',path: '/acceso',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PropuestaTokenRoute = PropuestaTokenRouteImport.update({
            id: '/propuesta/$token',path: '/propuesta/$token',getParentRoute: () => rootRouteImport
          })
const OauthConsentRoute = OauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => rootRouteImport
          })
const PortalIndexRoute = PortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalRoute
          })
const AuthenticatedPresentacionRoute = AuthenticatedPresentacionRouteImport.update({
            id: '/presentacion',path: '/presentacion',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppRoute = AuthenticatedAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => AuthenticatedRouteRoute
          })
const EventoTokenCancionesRoute = EventoTokenCancionesRouteImport.update({
            id: '/evento/$token/canciones',path: '/evento/$token/canciones',getParentRoute: () => rootRouteImport
          })
const PortalEventosIdRoute = PortalEventosIdRouteImport.update({
            id: '/eventos/$id',path: '/eventos/$id',getParentRoute: () => PortalRoute
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppWhatsappRoute = AuthenticatedAppWhatsappRouteImport.update({
            id: '/whatsapp',path: '/whatsapp',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppTareasRoute = AuthenticatedAppTareasRouteImport.update({
            id: '/tareas',path: '/tareas',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSolicitudesRoute = AuthenticatedAppSolicitudesRouteImport.update({
            id: '/solicitudes',path: '/solicitudes',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPresupuestosRoute = AuthenticatedAppPresupuestosRouteImport.update({
            id: '/presupuestos',path: '/presupuestos',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPagosRoute = AuthenticatedAppPagosRouteImport.update({
            id: '/pagos',path: '/pagos',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppLeadsRoute = AuthenticatedAppLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppHoyRoute = AuthenticatedAppHoyRouteImport.update({
            id: '/hoy',path: '/hoy',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppEventosRoute = AuthenticatedAppEventosRouteImport.update({
            id: '/eventos',path: '/eventos',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppContactosRoute = AuthenticatedAppContactosRouteImport.update({
            id: '/contactos',path: '/contactos',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppCompartirRoute = AuthenticatedAppCompartirRouteImport.update({
            id: '/compartir',path: '/compartir',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppClientesRoute = AuthenticatedAppClientesRouteImport.update({
            id: '/clientes',path: '/clientes',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppCancionesRoute = AuthenticatedAppCancionesRouteImport.update({
            id: '/canciones',path: '/canciones',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppCampanasRoute = AuthenticatedAppCampanasRouteImport.update({
            id: '/campanas',path: '/campanas',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppCalendarioRoute = AuthenticatedAppCalendarioRouteImport.update({
            id: '/calendario',path: '/calendario',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppArchivosRoute = AuthenticatedAppArchivosRouteImport.update({
            id: '/archivos',path: '/archivos',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppEventosIdRoute = AuthenticatedAppEventosIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppEventosRoute
          })
const AuthenticatedAppClientesIdRoute = AuthenticatedAppClientesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppClientesRoute
          })





const AuthenticatedAppClientesRouteChildren = {
  AuthenticatedAppClientesIdRoute: AuthenticatedAppClientesIdRoute
}

const AuthenticatedAppClientesRouteWithChildren = AuthenticatedAppClientesRoute._addFileChildren(AuthenticatedAppClientesRouteChildren)




const AuthenticatedAppEventosRouteChildren = {
  AuthenticatedAppEventosIdRoute: AuthenticatedAppEventosIdRoute
}

const AuthenticatedAppEventosRouteWithChildren = AuthenticatedAppEventosRoute._addFileChildren(AuthenticatedAppEventosRouteChildren)



const AuthenticatedAppRouteChildren = {
  AuthenticatedAppArchivosRoute: AuthenticatedAppArchivosRoute,AuthenticatedAppCalendarioRoute: AuthenticatedAppCalendarioRoute,AuthenticatedAppCampanasRoute: AuthenticatedAppCampanasRoute,AuthenticatedAppCancionesRoute: AuthenticatedAppCancionesRoute,AuthenticatedAppClientesRoute: AuthenticatedAppClientesRouteWithChildren,AuthenticatedAppCompartirRoute: AuthenticatedAppCompartirRoute,AuthenticatedAppContactosRoute: AuthenticatedAppContactosRoute,AuthenticatedAppEventosRoute: AuthenticatedAppEventosRouteWithChildren,AuthenticatedAppHoyRoute: AuthenticatedAppHoyRoute,AuthenticatedAppLeadsRoute: AuthenticatedAppLeadsRoute,AuthenticatedAppPagosRoute: AuthenticatedAppPagosRoute,AuthenticatedAppPresupuestosRoute: AuthenticatedAppPresupuestosRoute,AuthenticatedAppSolicitudesRoute: AuthenticatedAppSolicitudesRoute,AuthenticatedAppTareasRoute: AuthenticatedAppTareasRoute,AuthenticatedAppWhatsappRoute: AuthenticatedAppWhatsappRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute
}

const AuthenticatedAppRouteWithChildren = AuthenticatedAppRoute._addFileChildren(AuthenticatedAppRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAppRoute: AuthenticatedAppRouteWithChildren,AuthenticatedPresentacionRoute: AuthenticatedPresentacionRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const PortalRouteChildren = {
  PortalIndexRoute: PortalIndexRoute,PortalEventosIdRoute: PortalEventosIdRoute
}

const PortalRouteWithChildren = PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AccesoRoute: AccesoRoute,AvisoLegalRoute: AvisoLegalRoute,BodasRoute: BodasRoute,ContactoRoute: ContactoRoute,EventosRoute: EventosRoute,PortalRoute: PortalRouteWithChildren,PrivacidadRoute: PrivacidadRoute,PublicRoute: PublicRoute,SesionesRoute: SesionesRoute,OauthConsentRoute: OauthConsentRoute,PropuestaTokenRoute: PropuestaTokenRoute,EventoTokenCancionesRoute: EventoTokenCancionesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)